import * as v from "valibot";

import { rpcContract } from "../rpc";

export const publicPostsQueryRpcContract = rpcContract({
  name: "publicPostsQuery",
  paramsSchema: v.object({
    worldId: v.string(),
  }),
  resultSchema: v.object({
    worldName: v.string(),
    posts: v.array(
      v.object({
        id: v.string(),
        description: v.string(),
        imageUrl: v.nullable(v.string()),
        createdAt: v.string(),
        contentTier: v.union([v.literal("free"), v.literal("premium")]),
        hasAccess: v.boolean(),
        oneTimeProduct: v.optional(
          v.object({
            id: v.string(),
            priceCents: v.number(),
          }),
        ),
      }),
    ),
  }),
});

export type PublicPostsQueryParams = v.InferOutput<(typeof publicPostsQueryRpcContract)["paramsSchema"]>;
export type PublicPostsQueryResult = v.InferOutput<(typeof publicPostsQueryRpcContract)["resultSchema"]>;
export type PublicPost = v.InferOutput<(typeof publicPostsQueryRpcContract)["resultSchema"]>["posts"][0];
